/* This component is auto-generated with figma-svg. */
export enum IconView {
    Phone = 'Phone',
    Cross = 'Cross',
    Astrostar = 'Astrostar',
    Lupa = 'Lupa',
    Folder = 'Folder',
    Share = 'Share',
    Bubble = 'Bubble',
    List = 'List',
    Speedometer = 'Speedometer',
    Ghost = 'Ghost',
    Gift = 'Gift',
    Cart = 'Cart',
    Location = 'Location',
    QuestionMark = 'QuestionMark',
    Lifebuoy = 'Lifebuoy',
    Eye = 'Eye',
    Chevron = 'Chevron',
    Thumb = 'Thumb',
    Smiley = 'Smiley',
    Uturn = 'Uturn',
    ArrowPath = 'ArrowPath',
    User = 'User',
    Trash = 'Trash',
    PenSquare = 'PenSquare',
    Clock = 'Clock',
    Camera = 'Camera',
    Flag = 'Flag',
    Minus = 'Minus',
    Lock = 'Lock',
    Chart = 'Chart',
    Send = 'Send',
    Bars = 'Bars',
    Wallet = 'Wallet',
    Play = 'Play',
    Ellipsis = 'Ellipsis',
    Star = 'Star',
    Pause = 'Pause',
    MapPin = 'MapPin',
    Bot = 'Bot',
    Pin = 'Pin',
    Heart = 'Heart',
    Plus = 'Plus',
    Dots = 'Dots',
    Checkmark = 'Checkmark',
    Arrows = 'Arrows',
    Arrow = 'Arrow',
    Document = 'Document',
    Squares = 'Squares',
    Bell = 'Bell',
    Loader = 'Loader',
    ArrowRectangle = 'ArrowRectangle',
    Calendar = 'Calendar',
    Grid = 'Grid',
    Link = 'Link',
    ArrowSquare = 'ArrowSquare',
    Box = 'Box',
    Funnel = 'Funnel',
    Envelope = 'Envelope',
    Adjustments = 'Adjustments',
    Clip = 'Clip',
    Drawer = 'Drawer',
    Dataflow = 'Dataflow',
    Book = 'Book',
    Gear = 'Gear',
    Exclamation = 'Exclamation',
    Info = 'Info',
    Bolt = 'Bolt',
    ArrowLine = 'ArrowLine',
    Ban = 'Ban',
    Map = 'Map',
    Globe = 'Globe',
    Briefcase = 'Briefcase',
    Printer = 'Printer',
    Circle = 'Circle',
}

export interface IconPhone {
    scale: IconScale.Small | IconScale.Medium;
    kind: IconKind.Cross | IconKind.ArrowIn | IconKind.Default | IconKind.ArrowOut | IconKind.Wave;
    view: IconView.Phone;
}
export interface IconCross {
    scale: IconScale.Small | IconScale.Medium;
    enclosed?: IconEnclosed;
    view: IconView.Cross;
}
export interface IconAstrostar {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.Astrostar;
}
export interface IconLupa {
    scale: IconScale.Small | IconScale.Medium;
    kind: IconKind.Heart | IconKind.Default;
    appearance: IconAppearance.Outlined | IconAppearance.Filled;
    view: IconView.Lupa;
}
export interface IconFolder {
    kind: IconKind.Arrow | IconKind.Default | IconKind.Heart;
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Folder;
}
export interface IconShare {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Share;
}
export interface IconBubble {
    scale: IconScale.Medium | IconScale.Small;
    kind: IconKind.Single | IconKind.Double;
    appearance: IconAppearance.Filled | IconAppearance.Outlined;
    shape: IconShape.Square | IconShape.Round;
    view: IconView.Bubble;
}
export interface IconList {
    scale: IconScale.Small | IconScale.Medium;
    reduced?: IconReduced;
    view: IconView.List;
}
export interface IconSpeedometer {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Speedometer;
}
export interface IconGhost {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.Ghost;
}
export interface IconGift {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.Gift;
}
export interface IconCart {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Cart;
}
export interface IconLocation {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Location;
}
export interface IconQuestionMark {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.QuestionMark;
}
export interface IconLifebuoy {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.Lifebuoy;
}
export interface IconEye {
    scale: IconScale.MediumSmall | IconScale.Small | IconScale.Medium;
    crossed?: IconCrossed;
    view: IconView.Eye;
}
export interface IconChevron {
    scale: IconScale.ExtraSmall | IconScale.Small | IconScale.Medium;
    kind: IconKind.Up | IconKind.UpDown | IconKind.Down | IconKind.Left | IconKind.Right;
    view: IconView.Chevron;
}
export interface IconThumb {
    scale: IconScale.Small | IconScale.Medium;
    kind: IconKind.Down | IconKind.DownDown | IconKind.UpDown | IconKind.Up | IconKind.UpUp;
    reduced?: IconReduced;
    view: IconView.Thumb;
}
export interface IconSmiley {
    kind: IconKind.Sad | IconKind.Smirk | IconKind.Unhappy | IconKind.Happy | IconKind.Indiferent;
    view: IconView.Smiley;
}
export interface IconUturn {
    scale: IconScale.Medium | IconScale.Small;
    kind: IconKind.Right | IconKind.Left;
    view: IconView.Uturn;
}
export interface IconArrowPath {
    scale: IconScale.Medium | IconScale.Small;
    kind: IconKind.Clockwise | IconKind.Default;
    view: IconView.ArrowPath;
}
export interface IconUser {
    scale: IconScale.Medium | IconScale.Small;
    kind: IconKind.Double | IconKind.Single;
    enclosed?: IconEnclosed;
    view: IconView.User;
}
export interface IconTrash {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.Trash;
}
export interface IconPenSquare {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.PenSquare;
}
export interface IconClock {
    scale: IconScale.ExtraSmall | IconScale.Small | IconScale.Medium;
    kind: IconKind.Default | IconKind.Rewind;
    view: IconView.Clock;
}
export interface IconCamera {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Camera;
}
export interface IconFlag {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Flag;
}
export interface IconMinus {
    scale: IconScale.Medium | IconScale.Small;
    enclosed?: IconEnclosed;
    view: IconView.Minus;
}
export interface IconLock {
    scale: IconScale.Medium | IconScale.Small | IconScale.ExtraSmall;
    kind: IconKind.Unlocked | IconKind.Locked;
    view: IconView.Lock;
}
export interface IconChart {
    scale: IconScale.Small | IconScale.Medium;
    kind: IconKind.Bar | IconKind.Line;
    view: IconView.Chart;
}
export interface IconSend {
    scale: IconScale.Large | IconScale.Medium | IconScale.Small;
    appearance: IconAppearance.Outlined | IconAppearance.Filled;
    view: IconView.Send;
}
export interface IconBars {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.Bars;
}
export interface IconWallet {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.Wallet;
}
export interface IconPlay {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Play;
}
export interface IconEllipsis {
    scale: IconScale.Medium | IconScale.Small;
    kind: IconKind.Vertical | IconKind.Horizontal;
    view: IconView.Ellipsis;
}
export interface IconStar {
    scale: IconScale.Medium | IconScale.Small;
    appearance: IconAppearance.Outlined | IconAppearance.HalfFilled | IconAppearance.Filled;
    enclosed?: IconEnclosed;
    view: IconView.Star;
}
export interface IconPause {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Pause;
}
export interface IconMapPin {
    scale: IconScale.Medium | IconScale.Large | IconScale.Small;
    appearance: IconAppearance.Outlined | IconAppearance.Filled;
    view: IconView.MapPin;
}
export interface IconBot {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Bot;
}
export interface IconPin {
    scale: IconScale.Medium | IconScale.Small;
    appearance: IconAppearance.Outlined | IconAppearance.Filled;
    crossed?: IconCrossed;
    view: IconView.Pin;
}
export interface IconHeart {
    scale: IconScale.Medium | IconScale.Small | IconScale.MediumSmall;
    appearance: IconAppearance.Filled | IconAppearance.Outlined;
    view: IconView.Heart;
}
export interface IconPlus {
    scale: IconScale.Small | IconScale.Medium;
    enclosed?: IconEnclosed;
    view: IconView.Plus;
}
export interface IconDots {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Dots;
}
export interface IconCheckmark {
    scale: IconScale.Medium | IconScale.ExtraSmall | IconScale.Small;
    kind: IconKind.Single | IconKind.Double;
    appearance: IconAppearance.Outlined | IconAppearance.Filled;
    enclosed?: IconEnclosed;
    view: IconView.Checkmark;
}
export interface IconArrows {
    scale: IconScale.Medium | IconScale.Small;
    kind: IconKind.DiagonalIn | IconKind.DiagonalOut | IconKind.Default;
    view: IconView.Arrows;
}
export interface IconArrow {
    scale: IconScale.Small | IconScale.Medium;
    kind: IconKind.Right | IconKind.LeftUp | IconKind.UpDown | IconKind.Down | IconKind.Left | IconKind.Up;
    view: IconView.Arrow;
}
export interface IconDocument {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Document;
}
export interface IconSquares {
    scale: IconScale.Small | IconScale.Medium;
    intersect?: IconIntersect;
    view: IconView.Squares;
}
export interface IconBell {
    scale: IconScale.Small | IconScale.Medium;
    crossed?: IconCrossed;
    view: IconView.Bell;
}
export interface IconLoader {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Loader;
}
export interface IconArrowRectangle {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.ArrowRectangle;
}
export interface IconCalendar {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.Calendar;
}
export interface IconGrid {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.Grid;
}
export interface IconLink {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Link;
}
export interface IconArrowSquare {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.ArrowSquare;
}
export interface IconBox {
    scale: IconScale.Small | IconScale.Medium;
    kind: IconKind.Default | IconKind.Arrow;
    view: IconView.Box;
}
export interface IconFunnel {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.Funnel;
}
export interface IconEnvelope {
    scale: IconScale.Small | IconScale.Medium;
    kind: IconKind.Default | IconKind.Opened;
    view: IconView.Envelope;
}
export interface IconAdjustments {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Adjustments;
}
export interface IconClip {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.Clip;
}
export interface IconDrawer {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.Drawer;
}
export interface IconDataflow {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.Dataflow;
}
export interface IconBook {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.Book;
}
export interface IconGear {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Gear;
}
export interface IconExclamation {
    scale: IconScale.Medium | IconScale.Small;
    shape: IconShape.Circle | IconShape.Triangle;
    view: IconView.Exclamation;
}
export interface IconInfo {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Info;
}
export interface IconBolt {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Bolt;
}
export interface IconArrowLine {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.ArrowLine;
}
export interface IconBan {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Ban;
}
export interface IconMap {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.Map;
}
export interface IconGlobe {
    scale: IconScale.Small | IconScale.Medium;
    view: IconView.Globe;
}
export interface IconBriefcase {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.Briefcase;
}
export interface IconPrinter {
    scale: IconScale.Medium | IconScale.Small;
    view: IconView.Printer;
}
export interface IconCircle {
    scale: IconScale.Small | IconScale.Middle;
    appearance: IconAppearance.Outlined | IconAppearance.Filled;
    view: IconView.Circle;
}

export type IconInvariants =
    | IconPhone
    | IconCross
    | IconAstrostar
    | IconLupa
    | IconFolder
    | IconShare
    | IconBubble
    | IconList
    | IconSpeedometer
    | IconGhost
    | IconGift
    | IconCart
    | IconLocation
    | IconQuestionMark
    | IconLifebuoy
    | IconEye
    | IconChevron
    | IconThumb
    | IconSmiley
    | IconUturn
    | IconArrowPath
    | IconUser
    | IconTrash
    | IconPenSquare
    | IconClock
    | IconCamera
    | IconFlag
    | IconMinus
    | IconLock
    | IconChart
    | IconSend
    | IconBars
    | IconWallet
    | IconPlay
    | IconEllipsis
    | IconStar
    | IconPause
    | IconMapPin
    | IconBot
    | IconPin
    | IconHeart
    | IconPlus
    | IconDots
    | IconCheckmark
    | IconArrows
    | IconArrow
    | IconDocument
    | IconSquares
    | IconBell
    | IconLoader
    | IconArrowRectangle
    | IconCalendar
    | IconGrid
    | IconLink
    | IconArrowSquare
    | IconBox
    | IconFunnel
    | IconEnvelope
    | IconAdjustments
    | IconClip
    | IconDrawer
    | IconDataflow
    | IconBook
    | IconGear
    | IconExclamation
    | IconInfo
    | IconBolt
    | IconArrowLine
    | IconBan
    | IconMap
    | IconGlobe
    | IconBriefcase
    | IconPrinter
    | IconCircle;

export type IconEnclosed = boolean;
export type IconReduced = boolean;
export type IconCrossed = boolean;
export type IconIntersect = boolean;

export enum IconScale {
    Small = 'Small',
    Medium = 'Medium',
    MediumSmall = 'MediumSmall',
    ExtraSmall = 'ExtraSmall',
    Large = 'Large',
    Middle = 'Middle',
}
export enum IconKind {
    Cross = 'Cross',
    Heart = 'Heart',
    Arrow = 'Arrow',
    Single = 'Single',
    ArrowIn = 'ArrowIn',
    Default = 'Default',
    Up = 'Up',
    Down = 'Down',
    UpDown = 'UpDown',
    Left = 'Left',
    Right = 'Right',
    Sad = 'Sad',
    Clockwise = 'Clockwise',
    ArrowOut = 'ArrowOut',
    Double = 'Double',
    DownDown = 'DownDown',
    Wave = 'Wave',
    Unlocked = 'Unlocked',
    Bar = 'Bar',
    Vertical = 'Vertical',
    Smirk = 'Smirk',
    Locked = 'Locked',
    DiagonalIn = 'DiagonalIn',
    Unhappy = 'Unhappy',
    Rewind = 'Rewind',
    Opened = 'Opened',
    Happy = 'Happy',
    LeftUp = 'LeftUp',
    DiagonalOut = 'DiagonalOut',
    Indiferent = 'Indiferent',
    UpUp = 'UpUp',
    Horizontal = 'Horizontal',
    Line = 'Line',
}
export enum IconAppearance {
    Outlined = 'Outlined',
    Filled = 'Filled',
    HalfFilled = 'HalfFilled',
}
export enum IconShape {
    Square = 'Square',
    Circle = 'Circle',
    Triangle = 'Triangle',
    Round = 'Round',
}
